var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('nav-bar',{on:{"open-auth":_vm.onOpenAuth}}),_c('home-hero'),_c('home-features'),_c('home-products'),_c('home-news'),_c('home-notice'),_c('site-footer'),_c('auth-modal',{ref:"authModal",on:{"login-success":_vm.onLoginSuccess}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }